import service from "./request";

// const base_url = "http://10.255.33.7:31548";

// const isFullUrl = (url) => {
//   return /(http|https):\/\/([\w.]+\/?)\S*/.test(url);
// };

/**
 * 封装get请求
 * @param url
 * @param params
 * @param config
 * @returns {Promise}
 */

/**
 * @param {any} url
 * @param {any} params
 */
const get = (url, params, config = {}) =>
  new Promise((resolve, reject) => {
    service({
      ...config,
      method: "get",
      url,
      params,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });

/**
 * 封装post请求
 * @param url
 * @param data
 * @param config
 * @returns {Promise}
 */

const post = (url, data, config = {}) =>
  new Promise((resolve, reject) => {
    let params = {
      ...config,
      method: "post",
      url,
      data,
    };
    if (config?.headers?.["Content-Type"] === "x-www-form-urlencoded") {
      params = {
        ...params,
        params: data,
      };
    }

    service(params)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });

/**
 * 封装put请求
 * @param url
 * @param data
 * @param config
 * @returns {Promise}
 */

const put = (url, data, config = {}) =>
  new Promise((resolve, reject) => {
    let params = {
      ...config,
      method: "put",
      url,
      data,
    };

    service(params)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });

const deleteRequest = (url, config = {}) =>
  new Promise((resolve, reject) => {
    let params = {
      ...config,
      method: "delete",
      url,
    };
    service(params)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });

export default {
  get,
  post,
  put,
  deleteRequest,
};
